export const getEndTime = (time: string, duration: string): string => {
  const [hoursStr, minutesStr = "00"] = time.split(":");

  const baseHours = Number.parseInt(hoursStr, 10);

  const normalizedDuration = duration.toLowerCase();

  const hoursMatch = normalizedDuration.match(/(\d+)\s*час/);

  const durationHours = hoursMatch ? Number.parseInt(hoursMatch[1], 10) : 0;

  const minutesMatch = normalizedDuration.match(/(\d+)\s*мин/);

  const durationMinutes = minutesMatch
    ? Number.parseInt(minutesMatch[1], 10)
    : 0;

  if (Number.isNaN(baseHours)) {
    return time;
  }

  const baseMinutesRaw = Number.parseInt(minutesStr, 10);
  const baseMinutes = Number.isNaN(baseMinutesRaw) ? 0 : baseMinutesRaw;

  // Add duration correctly as hours+minutes (with carry into hours).
  const startTotalMinutes = baseHours * 60 + baseMinutes;
  const endTotalMinutes =
    startTotalMinutes + durationHours * 60 + durationMinutes;

  const endHours = ((Math.floor(endTotalMinutes / 60) % 24) + 24) % 24;
  const endMinutes = ((endTotalMinutes % 60) + 60) % 60;

  const hours = String(endHours).padStart(2, "0");
  const minutes = String(endMinutes).padStart(2, "0");

  return `${time}-${hours}:${minutes}`;
};

export const detachHidePdfElements = (root: HTMLElement): (() => void) => {
  const nodes = Array.from(root.querySelectorAll(".hide-pdf"));
  const snapshots: {
    parent: Node;
    nextSibling: ChildNode | null;
    node: HTMLElement;
  }[] = [];

  for (const node of nodes) {
    if (!(node instanceof HTMLElement) || !root.contains(node)) continue;
    const parent = node.parentNode;
    if (!parent) continue;
    snapshots.push({
      parent,
      nextSibling: node.nextSibling,
      node,
    });
    parent.removeChild(node);
  }

  return () => {
    for (const { parent, nextSibling, node } of snapshots) {
      if (nextSibling && parent.contains(nextSibling)) {
        parent.insertBefore(node, nextSibling);
      } else {
        parent.appendChild(node);
      }
    }
  };
};
